import { render, staticRenderFns } from "./KedingTipsTwo.vue?vue&type=template&id=78be45d2&scoped=true"
import script from "./KedingTipsTwo.vue?vue&type=script&lang=js"
export * from "./KedingTipsTwo.vue?vue&type=script&lang=js"
import style0 from "./KedingTipsTwo.vue?vue&type=style&index=0&id=78be45d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78be45d2",
  null
  
)

export default component.exports